// General
import React, { useContext } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { TextField, MenuItem } from "@mui/material";
// Formik
import { Formik, Form } from "formik";
// Contexts
import { BrandsContext } from "../../data/brands/BrandsContext";
import { useValidations } from "../../data/ValidationContext";
// Components
import CapitalizedFormikField from "../../components/CapitalizedFormikField";

const BrandsAddModal = ({ isOpen, onClose }) => {
  // Contextten markalar ve ekleme fonksiyonunu al
  const { brandsList, addBrand, statusdata } = useContext(BrandsContext);
  // Validation şemasını al
  const { vs_brand } = useValidations(); 

  // Formik için başlangıç değerleri
  const initialValues = {
    name: "",
    description: "",
    status: statusdata[0], 
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      {/* Formik setup */}
      <Formik
        initialValues={initialValues}
        validationSchema={vs_brand}
        onSubmit={(values) => {
          // Marka adı benzersiz mi kontrol et
          const isDuplicate = brandsList.some(
            (b) => b.name.toLowerCase() === values.name.toLowerCase()
          );
          if (isDuplicate) {
            alert("Bu marka zaten mevcut!");
            return;
          }

          // Marka ekleme
          addBrand({
            name: values.name,
            description: values.description,
            status: values.status,
          });

          // Modal kapat
          onClose();
        }}
      >
        {({ values, touched, errors, handleChange, setFieldValue }) => (
          <Form>
            {/* Modal Header */}
            <Modal.Header closeButton>
              <Modal.Title>Marka Ekle</Modal.Title>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body>
              <div className="d-flex flex-column gap-3">
                {/* Marka Adı */}
                <CapitalizedFormikField
                  name="name"
                  label="Marka Adı"
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />

                {/* Açıklama */}
                <CapitalizedFormikField
                  name="description"
                  label="Açıklama"
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  error={touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                />

                {/* Durum Seçimi */}
                <TextField
                  select
                  name="status"
                  label="Durum"
                  value={values.status}
                  onChange={(e) => setFieldValue("status", e.target.value)}
                  variant="outlined"
                  size="small"
                  fullWidth
                >
                  {statusdata.map((status, index) => (
                    <MenuItem key={index} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </Modal.Body>

            {/* Modal Footer */}
            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default BrandsAddModal;
